export default __webpack_public_path__ + "static/media/ALFA ROMEO.7692839c.png";